export default function ShippingAddressItem({ detail = {} }) {
  
  return (
    <>
      <div className="mb[20px] px-[34px] py-[20px] mdmax:hidden">
        <p className="text-[16px] font-bold">{detail.userName}</p>
        <p className="flex items-center py-[12px]">
          <i className="iconfont icon-location mr-[8px]"/>
          <span className="text-[14px]">{detail.userMobile}</span>
        </p>
        <p className="flex items-center">
          <i className="iconfont icon-mobile mr-[8px]"/>
          <span className="text-[14px]">{detail.userAddress}</span>
        </p>
      </div>
      
      <div className="mx-[3%] py-[15px] md:hidden">
        <div className="flex">
          <i className="iconfont icon-location pr-[10px]"></i>
          <div className="flex-1">
            <p className="mb-[5px]">
              <span className="font-bold text-[16px] pr-[10px]">{detail.userName}</span>
              <span className="text-[16px]">{detail.userMobile}</span>
            </p>
            <p>{detail.userAddress}</p>
          </div>
          {/*<div className="w-[45px] text-center">*/}
          {/*  <i className="iconfont icon-edit text-[22px]"></i>*/}
          {/*</div>*/}
        </div>
      </div>
    </>
  );
}
